import styled from 'styled-components';

import {InnerWidthContainer} from '~/shared/components/styled';
import MobileStandaloneHeader from '~/shared/components/MobileStandaloneHeader';

export const PageWidthContainer = styled(InnerWidthContainer)`
  margin-top: 64px;
`;

export const NewDesignHeader = styled(MobileStandaloneHeader)`
  background-color: ${({theme}) => theme.colors.surface};
  position: fixed;
  top: 0;
  z-index: ${({theme}) => theme.zIndex.header};
`;
